<template>
    <div ref="editCheckedRadio">
        <div  v-if="!editing">
            <span :class="customClass">{{ radioText }}</span>
            <i ref="editBtn" class="ri-pencil-line cursor-pointer" v-if="editable"></i>
        </div>
        <template v-else>
            <el-radio-group v-model="radio" text-color="#000" fill="#405189" @change="radioChange">
              <el-radio v-for="(item, index) in options" :key="index" :label="item.value"  :value="item.value">{{ item.label }}</el-radio>
            </el-radio-group>
        </template>
    </div>
</template>

<script>
export default {
emits:['complete'],
props: {
    // 接收对象列表
    options: {
      type: Array,
      default () {
        return []
      }
    },
    value:{
        type: [String ,Number,Boolean],
        default:''
    },
    editable: {
      type: Boolean,
      default: true,
    },
    customClass: {
      type: String,
      default: '',
    },
},     
data () {
    return {
        radio:'',
        editing: false,
    }
},
watch:{},
computed:{
  radioText(){
    return this.value?this.options[Number(this.value)-1].label:'';
  }
},
mounted(){
    if(this.value){
        this.radio = this.value  
        console.log( this.radio," this.radio this.radio");
    }
    document.addEventListener('click', this.clickMe);
},
beforeUnmount() {
    document.removeEventListener('click', this.clickMe);
},
methods:{
    startEditing() {
      this.editing = true;
    },
    clickMe(event) {
      const editBtnRef = this.$refs.editBtn
      if (editBtnRef) {
        if (editBtnRef.contains(event.target)) {
          this.startEditing()
          return;
        }
      }
      if (this.editing && !this.$refs.editCheckedRadio.contains(event.target)) {
        this.editing = false
        this.$emit('complete',this.radio)
      }
    },
    radioChange(value){
        this.radio = value
    }
}
}
</script>

<style lang="scss" scoped>

</style>